import { useState, useEffect } from 'react'
import { PageHeader } from '@/components/molecules'
import {
  DisplayPreReqContentTab,
  PageContent,
  UploadMedia
} from '@/components/organisms'
import { Tab, TabsNavigation } from '@/components/atoms'
import { Constants } from '@/utils/constants/commonConstants'
import { COLOR_CODE } from '@/utils/constants/colors'

const DisplayPreReqContent = ({
  mediaCardFormData,
  setMediaCardFormData,
  MediaCardUiSchema,
  displayPreReqContentFormData,
  setDisplayPreReqContentFormData,
  activeTab = 'parent',
  languages,
  targetType,
  handleTabClickPreReq
}) => {
  const [selectedTab, setSelectedTab] = useState(activeTab)

  useEffect(() => {
    setSelectedTab(activeTab)
  }, [activeTab])

  const handleTabChange = tab => {
    setSelectedTab(tab)
    handleTabClickPreReq(tab)
  }

  const handleFormChange = (tab, updatedTabData) => {
    setDisplayPreReqContentFormData(prev => {
      if (tab === 'parent') {
        return { ...prev, ...updatedTabData }
      }
      return {
        ...prev,
        child: {
          ...(prev?.child || {}),
          ...updatedTabData
        }
      }
    })
  }

  return (
    <>
      <PageContent className="sales-target-component bg-[#1D1D1D] text-white" pageContentWrapperClassName="relative">
        <div className="flex items-center justify-between">
          <PageHeader title="Display Content" color={COLOR_CODE._FFFFFF} />
        </div>

        <div className="space-y-6">
          <TabsNavigation
            data-testid="display-content-tabs"
            className="display-content-nav mb-6 w-full border-b border-gray-700"
            activeTabIndex={selectedTab === 'parent' ? 0 : 1}
          >
            {['parent', 'child'].map((tab, index) => (
              <Tab
                key={tab}
                data-testid={`tab-${tab}`}
                label={index === 0 ? 'Parent' : 'Child'}
                className="no-icon"
                onClick={() => handleTabChange(tab)}
                isDark
              />
            ))}
          </TabsNavigation>

          <DisplayPreReqContentTab
            key={selectedTab}
            formData={
              selectedTab === 'parent' ? displayPreReqContentFormData : displayPreReqContentFormData?.child || {}
            }
            setFormData={data => handleFormChange(selectedTab, data)}
            languages={languages}
            targetType={targetType}
          />
        </div>
      </PageContent>

      <PageContent className="sales-target-component bg-[#1D1D1D] text-white" pageContentWrapperClassName="relative">
        <PageHeader title="Add Target Card" color={COLOR_CODE._EFEFEF} />
        <div className="mb-4 flex items-center gap-1">
          <span className="material-icons-outlined text-sm text-white" role="img">
            info
          </span>
          <div className="text-sm text-[#D0D0D0]">Image will be used for both Parent and Child Targets.</div>
        </div>
        <UploadMedia
          mediaCardFormData={mediaCardFormData}
          setMediaCardFormData={setMediaCardFormData}
          uploadFor={Constants.SalesTarget}
          MediaCardUiSchema={MediaCardUiSchema}
          label="Target Display*"
          fileType="image"
        />
      </PageContent>
    </>
  )
}

export default DisplayPreReqContent
